/**
 * notify 相关
 */
import apis from 'src/const/apis';
import request from 'src/utils/request';

export default {
  namespaced: true,
  actions: {
    getCategoryInfo(store) {
      return request.get(apis.notify.categoryInfo);
    },
    getNotifyList(store, data) {
      return request.get(apis.notify.notify_list, data);
    },
    getNotifyInfo(store, data) {
      return request.get(apis.notify.getOne, data);
    },
    getNotifyConfig(store, data) {
      return request.get(apis.notify.config, data);
    },
    setNotifyConfig(store, data) {
      return request.post(apis.notify.config, data);
    },
    setReaded(store, data) {
      return request.post(apis.notify.read, data);
    },
    linkClick(store, data) {
      return request.post(apis.notify.click, data);
    },
  },
};
